export default __webpack_public_path__ + "assets/models/ee39fcf57061c255b7c3e0d605531921.glb";